import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';

import { logout } from '../../modules/Auth/AuthActions';
import { downloadAccountInvoices } from '../../modules/Accounts/AccountsActions';
import { getNotifications } from '../../modules/Notifications/NotificationsActions';

import Apps from '../Apps/Apps';
import Profile from '../Profile/Profile';
import AddPartnerModal from '../../modules/Partners/components/AddPartnerModal/AddPartnerModal';
import ChatFilter from '../../modules/Accounts/components/ChatFilter';
import ExportTrialConfig from '../../modules/Accounts/components/ExportTrialConfig';
import NotificationConfig from '../../modules/Notifications/components/NotificationConfig';

import profileImage from '../../assets/images/default-image.svg';
import chatIcon from '../../assets/images/chat-blue-icon.svg';
import trialIcon from '../../assets/images/trial-icon.svg';
import addIcon from '../../assets/images/add-circle.svg';

import './Header.scss';

class Header extends Component {
  getNotifications = () => {
    this.props.getNotifications({});
  };

  handleBulkExport = (selectedAccounts) => {
    for (const data of selectedAccounts) {
      if (data?.status !== 'trial') {
        this.props.downloadAccountInvoices(data?.subscriptionId, data?.accountId, data?.email);
      }
    }
  };

  renderChatFilterButton = () => {
    const { chatFilter } = this.props;
    return (
      <ChatFilter model={chatFilter}>
        <Button variant='secondary' size="sm">
          <img src={chatIcon} alt="#" />
          <span>Disable Chat</span>
        </Button>
      </ChatFilter>
    );
  };

  renderExportTrialButton = () => {
    return (
      <ExportTrialConfig>
        <Button variant='secondary' size='sm'>
          <img src={trialIcon} alt="#" />
          <span>Set Export Dates</span>
        </Button>
      </ExportTrialConfig>
    );
  };

  render() {
    const auth = this.props.auth;
    return (
      <div className='header'>
        <div className='right_parth'>
          {this.props.location.pathname === '/partners' && (
            <AddPartnerModal>
              <Button size="sm">
                <img src={addIcon} alt="Add partner"/> <span>Add partner</span>
              </Button>
            </AddPartnerModal>
          )}

          {(this.props.location.pathname === '/' || this.props.location.pathname === '/accounts') && (
            <React.Fragment>
              {this.props.auth.user.partner && this.props.auth.user.partner.role === 'owner' && this.renderChatFilterButton()}
              {this.props.auth.user.partner && this.props.auth.user.partner.role === 'owner' && this.renderExportTrialButton()}
            </React.Fragment>
          )}

          {this.props.location.pathname === '/notifications' && (
            <React.Fragment>
              <NotificationConfig onClose={this.getNotifications}>
                <Button size="sm">
                  <img src={addIcon} alt="Create Notification"/> <span>Create Notification</span>
                </Button>
              </NotificationConfig>
            </React.Fragment>
          )}

          <Apps></Apps>
          <Profile
            user={auth.user.name}
            email={auth.user.email}
            profileImage={auth.user.photo || profileImage}
            onClick={this.props.logout}
          ></Profile>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    downloadAccountInvoices: (subscriptionId, accountId, invoiceName) =>
      dispatch(downloadAccountInvoices(subscriptionId, accountId, invoiceName)),
    getNotifications: (params) => dispatch(getNotifications(params)),
  };
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    chatFilter: state.chat.filter,
    selectedAccounts: state.accounts.results?.filter((item) => item?.isSelected) ?? [],
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
